import { WebApiMemberDtoMemberDto } from "../Repository/eventbookyapi";
import { EmailNotificationPreference } from "../Types/EmailNotificationPreference";

/** A family member is a Member row linked to a primary member of the household. */
export const isFamilyMember = (m: WebApiMemberDtoMemberDto | null | undefined): boolean =>
    m?.primaryMemberId != null;

/**
 * Split a member list into billable primaries and household family members.
 * Family members share the primary's billing and must be excluded from
 * payment-link / invoice creation flows.
 */
export const splitPrimariesAndFamily = (members: WebApiMemberDtoMemberDto[]) => {
    const primaries = members.filter((m) => !isFamilyMember(m));
    const family = members.filter(isFamilyMember);
    return { primaries, family };
};

/** Recipient-type filter for the communication (email / SMS) send-list flows. */
export type RecipientTypeFilter = "all" | "primaries" | "family";

export const filterByRecipientType = (
    members: WebApiMemberDtoMemberDto[],
    filter: RecipientTypeFilter,
): WebApiMemberDtoMemberDto[] => {
    if (filter === "primaries") return members.filter((m) => !isFamilyMember(m));
    if (filter === "family") return members.filter(isFamilyMember);
    return members;
};

export const wantsNoEmail = (m: WebApiMemberDtoMemberDto | null | undefined): boolean =>
    m?.emailNotificationPreference === EmailNotificationPreference.NoInformationEmails;

export const familyDisplayName = (m: WebApiMemberDtoMemberDto): string => {
    const name = `${m.firstName ?? ""} ${m.lastName ?? ""}`.trim();
    return name.length > 0 ? name : m.email || m.phoneNumber || "";
};
